import { TEXTOS } from '../../../lib/glossario'

/**
 * O que esta tela ainda vai ter — dito em texto, e não em aba que não abre nada.
 *
 * O plano prevê seis abas no detalhe (Plano, Checklist, Comprovações, Comentários, Histórico, CAB)
 * e quatro existem. As outras não viram aba vazia: uma aba é uma promessa de conteúdo, e clicar
 * numa que responde "ainda não" é a experiência que faz o usuário parar de tentar as demais. No
 * sistema anterior o menu tinha itens assim — o kanban, por exemplo, abre uma tela que consulta
 * uma tabela que ninguém nunca preencheu.
 *
 * O que está escrito aqui sai de `docs/plano-gmud-v2.md` (seções 5 e 10). Não acrescente item:
 * quem lê esta tela é a fiscalização do contrato, e promessa que não está no plano vira cobrança.
 *
 * **E promessa CANCELADA é pior ainda.** Duas saíram desta lista em 26/08/2026, e as duas por
 * razões diferentes:
 *
 * - "Comentários" foi ENTREGUE, como observações da solicitação (`NotasDaGmud`, logo acima nesta
 *   mesma tela). Continuar prometendo o que já está no ar faz quem lê procurar noutro lugar.
 * - O rito do comitê — pauta da reunião, ata anexada — foi ELIMINADO do sistema pela revisão de
 *   escopo de 19/08/2026: reunião, quórum e ata acontecem no escritório. Ele não vai existir aqui, e
 *   uma promessa que nunca vai ser cumprida é uma cobrança que nunca vai ser satisfeita.
 */
const SECOES_FUTURAS = [
  {
    titulo: 'Checklist de pré-requisitos',
    fase: 'Fase 2',
    resumo: 'O que precisa estar cumprido antes de executar, item a item, cada um com a comprovação vinculada.',
  },
] as const

/**
 * As seções do detalhe que ainda não existem.
 *
 * @returns o aviso do que vem por aí
 */
export function SecoesFuturas() {
  return (
    <section className="rounded-xl border border-dashed border-slate-300 bg-white px-5 py-4">
      <h2 className="text-sm font-semibold text-slate-900">{TEXTOS.emConstrucao.titulo}</h2>
      <p className="mt-1 max-w-prose text-sm text-slate-600">
        Esta tela vai crescer. O que está listado abaixo ainda não foi entregue — está declarado aqui para você
        saber o que vem e, principalmente, o que ainda não dá para fazer por aqui.
      </p>
      <ul className="mt-4 grid gap-4 sm:grid-cols-2">
        {SECOES_FUTURAS.map((secao) => (
          <li key={secao.titulo}>
            <p className="flex flex-wrap items-center gap-2 text-sm font-medium text-slate-800">
              {secao.titulo}
              <span className="rounded-full bg-laranja-50 px-2 py-0.5 text-xs font-semibold text-laranja-700">
                {secao.fase}
              </span>
            </p>
            <p className="mt-0.5 max-w-prose text-xs text-slate-600">{secao.resumo}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}
